import { CallOverlayControllerProps, CallOverlayViewProps } from './callOverlayProps';
import { IntegrationControllerBaseConfig } from '../../../base';
import { CallOverlayController } from './callOverlayInterface';

export function createCallOverlayController(
    config: IntegrationControllerBaseConfig
): CallOverlayController {
    return {
        useProps(context, item, props): CallOverlayViewProps {
            return {
                isOpen: props.isOpen,
                onClose: props.onClose,
                callStatus: props.callStatus, // Pass through the actual call status
                upsert: {
                    integration: props.item.integration,
                    tool: props.item.tool,
                    thread: props.item.thread,
                    onEnd: props.onEnd,
                },
            };
        },
    };
}
